'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MenuNode from './MenuNode';
import MenuTree from './MenuTree';
import { jsx as _jsx } from "react/jsx-runtime";
class MenuRoot extends PureComponent {
  constructor(props) {
    super(props);
    this.getMenuComponent = this.getMenuComponent.bind(this);
  }
  getMenuComponent(isNode) {
    return isNode ? MenuTree : MenuNode;
  }
  get menuStyle() {
    return {
      minWidth: `${this.props.maxDepth * 24 + 650}px`
    };
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      style: this.menuStyle,
      children: /*#__PURE__*/_jsx(MenuTree, {
        parentId: this.props.parentId,
        nodes: this.props.nodes,
        getMenuComponent: this.getMenuComponent,
        moveNode: this.props.moveNode,
        depth: 0,
        menuId: this.props.menuId,
        readOnly: this.props.readOnly
      })
    });
  }
}
MenuRoot.propTypes = {
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  nodes: PropTypes.arrayOf(PropTypes.object),
  moveNode: PropTypes.func.isRequired,
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  maxDepth: PropTypes.number.isRequired,
  readOnly: PropTypes.bool
};
export default MenuRoot;